module.exports = __webpack_public_path__ + "static/media/400084_02.197c5a84.png";